import React, { useContext, useEffect, useState } from "react";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/en-gb';
import "./rcaCustom.css";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import ChartLoader from "../../Dashboard/Charginganalysis/ChartLoader";
import WaterMark from "../DashboardMain_Bus/WaterMark";

export default function RcaChartC(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  // code for multi chart with multi axis with comman zoom
  /**
  * ---------------------------------------
  * This demo was created using amCharts 5.
  * 
  * For more information visit:
  * https://www.amcharts.com/
  * 
  * Documentation is available at:
  * https://www.amcharts.com/docs/v5/
  * ---------------------------------------
  */

  // Create root element
  // https://www.amcharts.com/docs/v5/getting-started/#Root_element

  const [chartData, setChartData] = useState([])
  const [orgChartData, setorgChartData] = useState([])
  const getLineRes = (data) => {
    setorgChartData(data)
  }

  const dateTimeConverter = (arr, side, ecuLegend, signalLegend) => {
    var output = arr.map((s, index) => (
      { "date": new Date(s.sort[0]).setMinutes(new Date(s.sort[0]).getMinutes() - 330), "value": s.fields.hasOwnProperty(signalLegend) ? Number(s.fields[signalLegend]) : null }
    ));
    return { output, side, ecuLegend, signalLegend };
  }

  useEffect(() => {
    var output = orgChartData.map((s, index) => (
      dateTimeConverter(s["hugeArray"], s["side"], s["ecuLegend"], s["signalLegend"])
    ));
    setChartData(output);
  }, [orgChartData])

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "rca/getLineData", body: { filterdata: props.filterObject, SelectedLoop: props.dataChoosedC } }, getLineRes)
  }, [props.dataChoosedC])

  useEffect(() => {
    if (chartData.length > 0) {
      /**
   * ---------------------------------------
   * This demo was created using amCharts 5.
   * 
   * For more information visit:
   * https://www.amcharts.com/
   * 
   * Documentation is available at:
   * https://www.amcharts.com/docs/v5/
   * ---------------------------------------
   */

      // Create root element
      // https://www.amcharts.com/docs/v5/getting-started/#Root_element 
      // var root = am5.Root.new("chartdiv3");
      var root = am5.Root.new(props.id);

      // Set themes
      // https://www.amcharts.com/docs/v5/concepts/themes/ 
      root.setThemes([
        am5themes_Animated.new(root)
      ]);

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/xy-chart/
      var chart = root.container.children.push(am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        maxTooltipDistance: 0,
        pinchZoomX: true
      }));

      var date = new Date();
      date.setHours(0, 0, 0, 0);
      var value = 100;

      // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
      var xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
        maxDeviation: 0.2,
        // baseInterval: {
        //   timeUnit: "day",
        //   count: 1
        // },
        tooltipDateFormat: "HH:mm:ss MMM dd, yyyy",
        baseInterval: { timeUnit: "second", count: 1 },
        renderer: am5xy.AxisRendererX.new(root, {}),
        tooltip: am5.Tooltip.new(root, {})
      }));

      var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {})
      }));

      // Add series
      // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
      console.log("chartData___C", chartData);
      for (let i = 0; i < chartData.length; i++) {
        const element = chartData[i];
        // const dynamicColor = getRandomColor();

        var series = chart.series.push(am5xy.LineSeries.new(root, {
          name: `${element["ecuLegend"]} - ${element["signalLegend"]}`,
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "value",
          valueXField: "date",
          tooltip: am5.Tooltip.new(root, {
            pointerOrientation: "horizontal",
            labelText: "{valueY}",
          }),
        }));

        const lineColor = series.get('stroke');


        series.bullets.push(function () {
          var graphics = am5.Circle.new(root, {
            radius: 4,
            interactive: true,
            cursorOverStyle: "ns-resize",
            // stroke: series.get("stroke"),

            fill: am5.color(lineColor),
            stroke: am5.color(lineColor)
          });

          return am5.Bullet.new(root, {
            sprite: graphics
          });
        });

        date = new Date();
        date.setHours(0, 0, 0, 0);
        value = 0;

        series.data.setAll(element["output"]);

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        series.appear();
      }


      // Add cursor
      // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
      var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
        behavior: "none"
      }));
      cursor.lineY.set("visible", false);


      // Add scrollbar
      // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
      chart.set("scrollbarX", am5.Scrollbar.new(root, {
        orientation: "horizontal"
      }));

      // Add legend
      // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
      // var legend = chart.rightAxesContainer.children.push(am5.Legend.new(root, {
      let legend = chart.topAxesContainer.children.push(am5.Legend.new(root, {
        width: am5.percent(100),
        x: am5.percent(100),
        centerX: am5.percent(100),
        layout: am5.GridLayout.new(root, {
          maxColumns: 3,
          fixedWidthGrid: false
        })
      }));

      // It's is important to set legend data after all the events are set on template, otherwise events won't be copied
      legend.data.setAll(chart.series.values);

      // Make stuff animate on load
      // https://www.amcharts.com/docs/v5/concepts/animations/
      chart.appear(1000, 100);
      root._logo.dispose();
      return () => root.dispose();
    }
  }, [chartData])

  // const getRandomColor = () => {
  //   const letters = "0123456789ABCDEF";
  //   let color = "#";
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // };

  return (
    <>
      <WaterMark />
      {
        (isLoading) ? <ChartLoader /> :
          <div id={props.id} style={{ width: "100%", height: "350px" }}></div>
      }
    </>
  );
}
